import axios from "axios";
export async function get(organization_id: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/threats/organization/"+organization_id);
    return response.data;
}

export async function update(organization_id: string, data: FormData) {
    let response = await axios.post(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/threats/organization/"+organization_id+"/store",data);
    return response.data;
}